import Vue from 'vue'
let Hub = new Vue();
export default {
    // getApiUrl () {
    //     // return 'http://guanbo.jclang.me/index.php/'; // 测试环境地址
    //     // return 'https://api.artme.net.cn/index.php/'; // 正式环境地址
    //     return process.env.HOST
    // },
    getHub () {
        return Hub;
    },
    formatNumber (n) {
        n = n.toString()
        return n[1] ? n : '0' + n
    },
    // 对象的克隆
    cloneObj (obj) {
        var o;
        switch (typeof obj) {
            case 'undefined': break;
            case 'string': o = obj + ''; break;
            case 'number': o = obj - 0; break;
            case 'boolean': o = obj; break;
            case 'object':
                if (obj === null) {
                    o = null;
                } else {
                    if (obj instanceof Array) {
                        o = [];
                        for (var i = 0, len = obj.length; i < len; i++) {
                            o.push(this.cloneObj(obj[i]));
                        }
                    } else {
                        o = {};
                        for (var k in obj) {
                            o[k] = this.cloneObj(obj[k]);
                        }
                    }
                }
                break;
        default:
            o = obj;
            break;
        }
        return o;
    },
    // 转换时间日期格式
    addTime (m) {
        return m < 10 ? '0' + m : m
    },
    format (timeTemp) {
        let _self = this;
        let time = new Date(timeTemp * 1000);
        let y = time.getFullYear();
        let m = time.getMonth() + 1;
        let d = time.getDate();
        let h = time.getHours();
        let mm = time.getMinutes();
        let s = time.getSeconds();
        let date = y + '-' + _self.addTime(m) + '-' + _self.addTime(d) + ' ' + _self.addTime(h) + ':' + _self.addTime(mm) + ':' + _self.addTime(s);
        return date
    },
    // 获取url参数
    getQueryString (name) {
        var after = window.location.hash.split('?')[1];
        if (after) {
            var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
            var r = after.match(reg);
            if (r != null) {
                return decodeURIComponent(r[2]);
            } else {
                return null;
            }
        }
    },
    /* eslint-disable */
    getURLParameters (url) {
        return (url.match(/([^?=&]+)(=([^&]*))/g) || []).reduce((a, v) => ((a[v.slice(0, v.indexOf('='))] = v.slice(v.indexOf('=') + 1)), a), {})
    },
}
// const getURLParameters = url =>
//   (url.match(/([^?=&]+)(=([^&]*))/g) || []).reduce((a, v) => ((a[v.slice(0, v.indexOf('='))] = v.slice(v.indexOf('=') + 1)), a), {});



// WEBPACK FOOTER //
// ./src/util/util.js